import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import PaymentOptionFormMixin from '@/helpers/vue_mixins/v2/PaymentOptionFormMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import CreatePaymentOption from '@/plugins/graphql/mutations/v2/payment-option-create.gql';
import UpdatePaymentOption from '@/plugins/graphql/mutations/v2/payment-option-update.gql';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { PaymentOptionBankDetailInputModel } from '@/helpers/entities/models/PaymentOptionBankDetailInputModel';
import { successfulCreate, successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import { isNotFirstInstance } from '@/helpers';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
const notDeleted = (detail) => !detail.isDeleted;
let PaymentOptionFormBank = class PaymentOptionFormBank extends mixins(PaymentOptionFormMixin, RouterParamsAppMixin, ViewportSizeMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.bankName = 'Bank Name';
        this.accountName = 'Account Name';
        this.accountNumber = 'Account Number';
        this.form = {
            paymentName: null,
            bankDetails: [],
        };
    }
    get detailsInput() {
        return this.form
            .bankDetails.filter(notDeleted)
            .map((detail) => {
            return {
                bankName: detail.bankName,
                accountName: detail.accountName,
                accountNumber: detail.accountNumber,
            };
        });
    }
    // Filter deleted subcategory in vuelidate sub categories object
    // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
    get bankDetails() {
        const collection = this.$v.form.bankDetails.$each.$iter || {};
        const result = Object.values(collection).reduce((acc, val) => {
            if (!val.$model.isDeleted) {
                acc.push(val);
            }
            return acc;
        }, []);
        return result;
    }
    onPaymentGatewayChanged(val) {
        const option = val.paymentOption;
        let bankDetails = [];
        if (option) {
            if (option.bankDetails) {
                bankDetails = option.bankDetails.map((detail) => {
                    return new PaymentOptionBankDetailInputModel(detail);
                });
            }
            this.form = {
                paymentName: option.paymentName,
                bankDetails,
            };
        }
    }
    addBankDetails() {
        const detail = new PaymentOptionBankDetailInputModel();
        this.form.bankDetails.push(detail);
    }
    isNotFirstDetailInstance(i) {
        return isNotFirstInstance(i);
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.submit();
        }
    }
    async submit() {
        this.requestOnFlight();
        const mutation = () => {
            const option = this.paymentGateway.paymentOption;
            if (option) {
                return this.sendUpdateMutation(option.uuid);
            }
            return this.sendCreateMutation();
        };
        await mutation()
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async sendCreateMutation() {
        return this.create().then(() => {
            const msg = successfulCreate(this.label);
            this.paymentManagerAction('SUBMIT CREATE', this.form.paymentName);
            this.successNotification(msg);
            this.success();
        });
    }
    async sendUpdateMutation(optionUuid) {
        return this.update(optionUuid).then(() => {
            const msg = successfulUpdate(this.label);
            this.paymentManagerAction('SUBMIT EDIT', this.form.paymentName);
            this.successNotification(msg);
            this.success();
        });
    }
    async create() {
        const vm = this;
        const paymentGatewayUuid = this.paymentGateway.uuid;
        this.$apollo.mutate({
            mutation: CreatePaymentOption,
            variables: {
                input: {
                    appUuid: this.appUUID || this.appUuid,
                    paymentGatewayUuid,
                    paymentName: this.form.paymentName,
                    bankDetails: this.detailsInput,
                },
            },
            update(cache, { data }) {
                vm.syncPaymentGatewayCache(cache, data.paymentOptionCreate.option, paymentGatewayUuid);
            },
        });
    }
    async update(optionUuid) {
        return this.$apollo.mutate({
            mutation: UpdatePaymentOption,
            variables: {
                input: {
                    optionUuid,
                    paymentName: this.form.paymentName,
                    bankDetails: this.detailsInput,
                },
            },
        });
    }
    mounted() {
        if (this.form.bankDetails.length === 0) {
            this.addBankDetails();
        }
    }
};
__decorate([
    Watch('paymentGateway', { immediate: true, deep: true })
], PaymentOptionFormBank.prototype, "onPaymentGatewayChanged", null);
PaymentOptionFormBank = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
            FormHeader,
        },
        validations: {
            form: {
                paymentName: {
                    required,
                },
                bankDetails: {
                    $each: {
                        bankName: {
                            required: requiredIf(notDeleted),
                            unique(value) {
                                const vm = this;
                                if (!value) {
                                    return true;
                                }
                                const { bankDetails } = vm.$data.form;
                                const match = bankDetails.filter((bd) => {
                                    return bd.bankName === value && !bd.isDeleted;
                                });
                                /* Identify uniqueness via length
                                   * Matcher will exclude current object that's why we assume
                                   object is not unique if matches with more than one object
                                   *- 0: false, 1*: true
                                   */
                                return !(match.length > 1);
                            },
                        },
                        accountName: {
                            required: requiredIf(notDeleted),
                        },
                        accountNumber: {
                            required: requiredIf(notDeleted),
                        },
                    },
                },
            },
        },
    })
], PaymentOptionFormBank);
export default PaymentOptionFormBank;
